export default __webpack_public_path__ + "images/5e2429eaa1a66b18dc4e317c9391cd74.jpg";